import React, { FC } from 'react';

import { LucidTheme, Component } from '../../../types/types';
import Card from '../../card/card';

export interface HeadingCardProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  variant?: Component.Type['Cards']['Card'];
  headingVariant?: Component.Type['Heading'];
  isDisabled?: boolean;
}

const HeadingCard: FC<HeadingCardProps> = ({
  imageSrc,
  imageAlt,
  title,
  variant = 'interactive',
  headingVariant,
  isDisabled,
}) => (
  <Card
    css={{
      label: 'headingCard',
      minWidth: '220px',
      minHeight: '172px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
    isDisabled={isDisabled}
    variant={variant}
  >
    <Card.Image
      alt={imageAlt || ''}
      css={(theme: LucidTheme) => [
        {
          padding: theme.space.s16,
        },
        isDisabled && {
          opacity: 0.35,
        },
      ]}
      src={imageSrc}
    />
    <Card.Content
      css={(theme: LucidTheme) => [
        {
          width: '100%',
          backgroundColor: theme.colors.orange[45],
          borderRadius: `0 0 ${theme.radii.card} ${theme.radii.card}`,
        },
        isDisabled && {
          backgroundColor: theme.colors.coolGrey[5],
        },
      ]}
    >
      <Card.Title
        css={(theme: LucidTheme) => [
          {
            margin: theme.space.s16,
            color: theme.colors.white,
          },
          isDisabled && {
            backgroundColor: theme.colors.coolGrey[5],
            color: theme.colors.coolGrey[50],
          },
        ]}
        variant={headingVariant}
      >
        {title}
      </Card.Title>
    </Card.Content>
  </Card>
);

export default HeadingCard;
